module.exports = __webpack_public_path__ + "media/message1.a57a8c53.mp3";